import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TcValueList, tcValueLabel } from '../pipes/tc-value-label.pipe';

export type TestCaseSelectionListKey =
  | 'test-case-type'
  | 'test-case-test-type'
  | 'test-case-status'
  | 'test-case-automation-status';

export interface TestCaseSelectionValue {
  key: string;
  label: string | null;
  standard: boolean;
  active: boolean;
  geschuetzt: boolean;
}

export interface TestCaseSelectionList {
  listKey: TestCaseSelectionListKey;
  werte: TestCaseSelectionValue[];
}

const PIPE_LISTE: Record<TestCaseSelectionListKey, TcValueList> = {
  'test-case-type': 'type',
  'test-case-test-type': 'testType',
  'test-case-status': 'status',
  'test-case-automation-status': 'automationStatus',
};

@Injectable({ providedIn: 'root' })
export class TestCaseSelectionListService {
  private readonly http = inject(HttpClient);
  private readonly translate = inject(TranslateService);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<TestCaseSelectionList[]> {
    return this.http.get<TestCaseSelectionList[]>(`${this.base}/${projectId}/test-case-selection-lists`);
  }

  /** Eigene Beschriftung des Projekts, sonst die Standardbezeichnung aus i18n. */
  beschriftung(listKey: TestCaseSelectionListKey, wert: TestCaseSelectionValue): string {
    return wert.label?.trim() || tcValueLabel(this.translate, PIPE_LISTE[listKey], wert.key);
  }

  beschriftungZuSchluessel(
    listKey: TestCaseSelectionListKey,
    key: string,
    werte: readonly TestCaseSelectionValue[],
  ): string {
    const wert = werte.find((w) => w.key === key);
    return wert ? this.beschriftung(listKey, wert) : tcValueLabel(this.translate, PIPE_LISTE[listKey], key);
  }
}
